import { render } from "./Document.vue?vue&type=template&id=1eac17b4&scoped=true"
import script from "./Document.vue?vue&type=script&setup=true&lang=js"
export * from "./Document.vue?vue&type=script&setup=true&lang=js"

import "./Document.vue?vue&type=style&index=0&id=1eac17b4&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/linker-marketplace-web/linker-marketplace-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1eac17b4"],['__file',"resources/js/components/whatsapp-managment/includes/types/Document.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1eac17b4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1eac17b4', __exports__)) {
    console.log('reload')
    api.reload('1eac17b4', __exports__)
  }
  
  module.hot.accept("./Document.vue?vue&type=template&id=1eac17b4&scoped=true", () => {
    console.log('re-render')
    api.rerender('1eac17b4', render)
  })

}


export default __exports__